'use client';
import { useContext } from 'react';
import { CouponIdContext } from './CouponIdContext.js';
/**
 * Component to update current coupon type in context. Coupon type is used to compose the Coupon ID to identify which coupon
 * that should be used within the application.
 * Always set new couponType immediately for navigation that uses useCouponId. This is to prevent bug where couponType is not cleaned up from previous mount.
 *
 * @param root0 Component props
 * @param root0.type Coupon type to set in context
 * @param root0.children Component children to render
 * @returns React component children
 */
export function CouponType({ type, children }) {
    const couponTypeContext = useContext(CouponIdContext);
    // Always set type immediately for dependent components
    couponTypeContext?.setType(type);
    /*
     * For future reference, this effect was removed since cleanup on back navigation was causing issues where couponType was set to undefined.
     * New usages is that Provider must always be set to prevent bug, since it will never be cleaned up until the new component mounts.
     */
    // useEffect(() => {
    //   // set coupon type again since effect clean up will clear it on route change after next coupon type is set.
    //   couponTypeContext?.setType(type);
    //   return (): void => {
    //     // Clear the coupon type when component unmounts
    //     couponTypeContext?.setType(undefined);
    //   };
    // }, [couponTypeContext, type]);
    return children;
}
//# sourceMappingURL=CouponType.js.map